import React, {useState, useEffect, useContext} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types';
import StepsLoader from "../steps-loader";
import StepFooterAction from "../../base-components/step-footer-action";
import BaseParagraph from "../../base-components/base-paragraph";
import { ImPencil } from 'react-icons/im';
import {useHistory} from "react-router-dom";
import { BASE_URL } from '../../../env';
import NACE from "assets/data/NACE.json";
import { CountryContext } from 'contexts/country-context';
import getStep from '../../../helpers/getStep';

const SummaryProStep = ({ _step_service, step_ID, next_step, setDataToContext }) => {
    const countryValue = useContext(CountryContext)
    const lang = localStorage.getItem('language')

    const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`

    const [isLoading, setIsLoading] = useState(false)
    const [isValid, setIsValid] = useState(false)
    const history = useHistory();

    const [name, setName] = useState('')
    const [number, setNumber] = useState('')
    const [establishmentDate, setEstablishmentDate] = useState('')
    const [acivity, setActivity] = useState('')
    const [country, setCountry] = useState('')
    const [hasEnterprise, setHasEnterprise] = useState(false)
    const [ready, setReady] = useState(false)

    const fetch_POST_init_options = {
        method: 'POST',
        credentials: "include",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',            
        }
    }

    const fetch_GET_init_options = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',            
        }
    }

    const fetch_POST_init = {
        ...fetch_POST_init_options,
        body: JSON.stringify(
            [{
            fieldId: "internal_confirm_flag",
            fieldValue: "1"
            }]
        )
    }

    useEffect(() => {
        getData()
        getStep(["internal_entreprise_country_name"]).then(res => {
            res["internal_entreprise_country_name"] !== "null" && setDataToContext("enterprise_activity_country", "", "internal_entreprise_country_name",  JSON.parse(res["internal_entreprise_country_name"]));
        })
                    if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                        pageID: "onboarding",
                        stepSeq: "3",
                        stepName: "pro info:review",
                        eventAction: "stepEnd",
                        flowType: "sales",
                        flowName: "onboarding",
                        productName: "onboarding",
                        trackMethod: "flow"
                    }
                );
            }
    }, [])
    
    async function getData() {
        // has_enterprise
        const hasEnterprise = await (await fetch(`${base_URL}/has_enterprise`, fetch_GET_init_options)).json()
        setHasEnterprise(hasEnterprise.fieldValue === "1")

        const name = await (await fetch(`${base_URL}/enterprise_name`, fetch_GET_init_options)).json()
        setName(name.fieldValue)

        const establishment_date = await (await fetch(`${base_URL}/establishment_date`, fetch_GET_init_options)).json()
        setEstablishmentDate((establishment_date.fieldValue).split('-').reverse().join('/'))

        const nace = await (await fetch(`${base_URL}/enterprise_activity_code`, fetch_GET_init_options)).json()
        const naceCode = nace.fieldValue.split(",").reverse()[0]
        const _naceCOde = NACE.find(nace => nace.CODE === naceCode)
        setActivity(_naceCOde[`NAME_${lang}`])

        const countryActivity = await (await fetch(`${base_URL}/enterprise_activity_country`, fetch_GET_init_options)).json()
        const __countryActivity = await (await fetch(`${BASE_URL}/onboarding-entrepreneur-front/v1/countries/${lang}`, fetch_GET_init_options)).json()

        const countryArr = []
        countryActivity.fieldValue.split(';').forEach(code => countryArr.push(__countryActivity.find(c => c.iso2 === code).title))
        setCountry(countryArr.join(","))

        const num = await (await fetch(`${base_URL}/enterprise_number`, fetch_GET_init_options)).json()
        setNumber(num.fieldValue.replace(/[0-9_]{4}?/, '$&.').replace(/[0-9_]{4}.[0-9_]{3}?/, '$&.'))

     
    }
    useEffect(() => {
        if (hasEnterprise) {
   if ( [ name, number, acivity, country].every(a => a !== '')) {
            setReady(true)
        }
        } else {
   if ( [ name, acivity, country].every(a => a !== '')) {
            setReady(true)
        }
        }
  
    }, [name, number, acivity, country])

    const action = () => {
        fetch(base_URL, fetch_POST_init).catch( error => {
            console.log("error : "+ error)
        })

        if (hasEnterprise) {
            setIsLoading(true)
            fetch(`${base_URL}/activation/ACTDS2`, fetch_POST_init_options).catch( error => {
                console.log("error : "+ error)
            }).then(res => {
                setIsLoading(false)
                history.push(`/${lang.toLowerCase()}/confirmation`);
            })
        } else {
                history.push(`/${lang.toLowerCase()}/pre-confirmation`);
        }
    }

    return (
        <>
            <StepsLoader step_ID={step_ID} loading={isLoading}>
                <BaseParagraph>
                    <h3>{t('pro_infos.pro_info_review.title')}</h3>
                </BaseParagraph>
                <ul className="summary-block">

                    {hasEnterprise && 
                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("pro_infos.pro_info_review.enterprise_number") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {number} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("enterprise-number" )
                        }}> <ImPencil /> </div>
                    </li>
                    }
                        
                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("pro_infos.pro_info_review.enterprise_name") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {name} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push(hasEnterprise ? "has-enterprise-name" : "enterprise-name")
                        }}> <ImPencil /> </div>
                    </li>

                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("pro_infos.pro_info_review.establishment_date") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {establishmentDate} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push(hasEnterprise ? "has-enterprise-name" : "enterprise-name")
                        }}> <ImPencil /> </div>
                    </li>
                    
                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("pro_infos.pro_info_review.enterprise_activity") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> {acivity} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("enterprise-activity-code")
                        }}> <ImPencil /> </div>
                    </li>
                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("pro_infos.pro_info_review.enterprise_country") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask > {country} </div>
                        <div className={"edit_field"} onClick={() => {
                            history.push("enterprise-activity-country")
                        }}> <ImPencil /> </div>
                    </li>
                    <li className={"summary-block__summary-field"}>
                        <div className="summary-block__summary-field__title"> { t("pro_infos.pro_info_review.legal_title") } </div>
                        <div className="summary-block__summary-field__value data-cs-mask" data-cs-mask> { t("pro_infos.pro_info_review.legal_label") }  </div>
                    </li>
                </ul>
                
                <StepFooterAction caption={t('pro_infos.pro_info_review.cta')} action={action} disabled={!ready} />
                
            </StepsLoader> 
        </>
    )
}

SummaryProStep.propTypes = {
    name: PropTypes.string
}

SummaryProStep.defaultProps = {
    name: "email-step"
}


export default SummaryProStep